var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.524 1.10095C18.1587 1.73555 18.1587 2.76445 17.524 3.39905L8.9231 12L17.524 20.601C18.1586 21.2356 18.1586 22.2644 17.524 22.899C16.8894 23.5337 15.8606 23.5337 15.226 22.899L5.47595 13.149C4.84135 12.5144 4.84135 11.4856 5.47595 10.851L15.226 1.10095C15.8606 0.466349 16.8894 0.466349 17.524 1.10095Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.84c8eaf0535e1832e6baa8130aaa65ff.svg";
export { ForwardRef as ReactComponent };